<template>
<div style="background-color: #fff;padding:10px">
<!--      <el-row>-->
<!--        <el-col :span="4"><div class="grid-content bg-purple btn">-->
<!--          <span class="el-icon-arrow-left" @click="bk()">返回</span>-->
<!--        </div></el-col>-->
<!--        <el-col :span="20"><div class="grid-content bg-purple-light ns">-->
<!--          <span>物流信息查询</span>-->
<!--        </div></el-col>-->
<!--      </el-row>-->
<!--      <div class="ins">-->
<!--        <el-input  prefix-icon="iconfont el-icon-search" v-model="searchStr"  placeholder="输入公司或商品名称" size="mini" style="margin-top: 23px; width: 85%;">-->
<!--        </el-input>-->
<!--        <button type="primary" size="mini" @click="selectD()">搜索</button>-->
<!--      </div>-->
  <div style="display: flex;justify-content: space-between;align-items: center">
    <div style="width: 83%">
      <el-input prefix-icon="iconfont el-icon-search" v-model="searchStr"
                placeholder="输入公司或商品名称" size="mini" class="inputSty2" style="background:#E8E8E8;border-radius: 2px;outline: medium">
      </el-input>
    </div>

    <button type="primary" size="mini" @click="selectD()" style="background-color: #ff9901;border: 1px solid #ff9901;color: #fff;border-radius: 4px">查询</button>

  </div>
      <div class="cenBox" v-for="item in options">
        <el-row :gutter="20">
          <el-col :span="2"><div class="grid-content bg-purple">
            <img src="./../../assets/images/wu.png" style="width: 27px;height: 27px;margin-top: 10px;margin-left: -5px">
          </div></el-col>
          <el-col :span="22"><div class="grid-content bg-purple">
            <p style="color: #4B616C;font-size: 15px">{{item.institution_name}}</p>
            <p class="ls">{{item.goods_name}}</p>
            <p class="ls">国药准字{{item.goods_code}}</p>
            <p class="ls">生产厂家：{{item.factory_name}}</p>
            <el-row>
              <el-col :span="12"><div class="grid-content bg-purple">
                <p class="ls1">入库数量：{{item.storage_quantity}}</p>
                <p class="ls1">未到货数量：{{item.quantity_not_arrived}}</p>
              </div></el-col>
              <el-col :span="12"><div class="grid-content bg-purple-light">
                <p class="ls1">出库数量：{{item.delivery_quantity}}</p>
                <p class="ls1">签收数量：{{item.signed_quantity}}</p>
              </div></el-col>
            </el-row>
          </div></el-col>
        </el-row>
        <div style="width:100%;height:1px;margin:0px auto;padding:0px;background-color:#D5D5D5;overflow:hidden;"></div>
      </div>
</div>
</template>

<script>
import http from "../../APIService/http";

export default {
  name: "login8",
  data(){
    return{
      options:[],
      searchStr: "",
      tenant_id: "1472813523",
      offset: 0,
    }
  },
  methods:{
    bk(){
      this.$router.push({path: '/reportIndex'})
    },
    selectD(){
      let that=this
      let forms={
        searchStr:this.searchStr,
        tenant_id:this.tenant_id,
        offset:this.offset
      }
      http.post('/wapi/gkGetFeedback/GkLogisticsInformation',forms)
          .then(function (res) {
            that.options = res.data.data
            console.log(that.options)
          })
    }
  },
  created() {
    this.selectD()
  }
}
</script>

<style lang="scss">
  .inputSty2 /deep/ span.el-input__prefix{
    left: 72px;

  }
  .inputSty2 /deep/ .el-input__inner{
    background: #f3f0f0;
    color: black;
    text-align: center;
  }
  .cenBox{
    padding-left: 10px;
  }
  .c1{
    margin-left: 80px;
    padding-top: 13px;
    position: absolute;
    font-size: 18px;
    color: #4D586D;
  }
  .ins{

    input{
      margin-top: -10px;
    }
  }
  .el-progress__text{
    font-size: 14px!important;
    color: #FF9901;
  }

  /*input.el-input__inner{*/
  /*  background: #f3f0f0;*/
  /*  color: black;*/
  /*  text-align: center;*/
  /*}*/
  .btn{
    color: #FF9901;
  }
  .ls{
    font-size: 14px;
    color: #c1bbb5;
    margin-top: -7px;
  }
  .ls1{
    font-size: 14px;
    color: orange;
    margin-top: -7px;
  }
  .el-card__body {
    padding: 5px;
  }
  .ns{
    margin-top: 10px;
    margin-left: 80px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/gkReport/Logistics.vue